
// import React from "react";
// import champPhoto from "../assets/paralightChampPic.jpg";
// import ParalightLogo from "../assets/paralightBG.jpg"


// const HeroSection = ({ onDownload }) => (
//   <section style={styles.section}>
//     <div style={styles.textContainer}>
//       <h1 style={styles.heading}>Stream Smarter with Paralight TV</h1>
//       <p style={styles.paragraph}>Works on Firestick & Android TV</p>
//       <button style={styles.button} onClick={onDownload}>Download Now</button>
//     </div>
//     <img src={champPhoto} alt="Paralight Champion" style={styles.image} />
//   </section>
// );

// export default HeroSection;

// const styles = {
//     section: {
//       display: "flex",
//       flexDirection: "row",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "3rem 2rem",
//       flexWrap: "wrap",
//       textAlign: "center",
//       gap: "2rem",
//     },
//     textContainer: {
//       flex: "1 1 300px",
//       maxWidth: "500px",
//       margin: "0 auto",
//       color: "#fff",
//     },
//     heading: {
//       fontSize: "2.5rem",
//       marginBottom: "1rem",
//     },
//     paragraph: {
//       fontSize: "1.2rem",
//       marginBottom: "1.5rem",
//     },
//     button: {
//       backgroundColor: "#ff5c00",
//       color: "#fff",
//       padding: "0.75rem 1.5rem",
//       border: "none",
//       borderRadius: "8px",
//       fontSize: "1rem",
//       cursor: "pointer",
//     },
//     image: {
//       flex: "1 1 300px",
//       maxWidth: "400px",
//       width: "100%",
//       borderRadius: "12px",
//       objectFit: "cover",
//     },
//   };
  import React from "react";
import champPhoto from "../assets/paralightChampPic.jpg";
import ParalightLogo from "../assets/paralightBG.jpg";

const HeroSection = ({ onDownload }) => (
  <section style={styles.section}>
    <div style={styles.textContainer}>
      <h1 style={styles.heading}>Stream Smarter with Paralight TV</h1>
      <p style={styles.paragraph}>Works on Firestick & Android TV</p>

      <button style={styles.button} onClick={onDownload}>Download Now</button>

      {/* ⭐ Added italic version text */}
      <p style={styles.versionText}><em>Current version 8.0.0</em></p>
    </div>

    <img src={champPhoto} alt="Paralight Champion" style={styles.image} />
  </section>
);

export default HeroSection;

const styles = {
  section: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem 2rem",
    flexWrap: "wrap",
    textAlign: "center",
    gap: "2rem",
  },
  textContainer: {
    flex: "1 1 300px",
    maxWidth: "500px",
    margin: "0 auto",
    color: "#fff",
  },
  heading: {
    fontSize: "2.5rem",
    marginBottom: "1rem",
  },
  paragraph: {
    fontSize: "1.2rem",
    marginBottom: "1.5rem",
  },
  button: {
    backgroundColor: "#ff5c00",
    color: "#fff",
    padding: "0.75rem 1.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    cursor: "pointer",
  },

  // ⭐ New style
  versionText: {
    marginTop: "0.5rem",
    fontSize: "0.9rem",
    opacity: 0.8,
  },

  image: {
    flex: "1 1 300px",
    maxWidth: "400px",
    width: "100%",
    borderRadius: "12px",
    objectFit: "cover",
  },
};
